import { shouldBlockSessionHydration } from '../utils/authFlow';

const isAuthStorageKey = (key = '') => (
  key === 'supabase.auth.token'
  || key === 'sb-access-token'
  || key === 'sb-refresh-token'
  || (key.startsWith('sb-') && key.includes('auth-token'))
);

/**
 * Supabase sessions must have one source of truth across browser tabs.
 *
 * Older builds mirrored the token into sessionStorage. A signed-out tab could
 * then be silently signed back in when another tab restored its stale copy.
 * Keep the durable session in localStorage only and remove legacy per-tab
 * copies whenever Supabase touches an auth key.
 */
export const createSupabaseAuthStorage = ({
  local = window.localStorage,
  session = window.sessionStorage,
} = {}) => ({
  getItem: (key) => {
    try {
      if (isAuthStorageKey(key)) {
        session.removeItem(key);
        if (shouldBlockSessionHydration()) return null;
      }

      return local.getItem(key);
    } catch (error) {
      console.error('[supabaseAuthStorage] getItem failed:', error);
      return null;
    }
  },

  setItem: (key, value) => {
    try {
      local.setItem(key, value);
      if (isAuthStorageKey(key)) {
        session.removeItem(key);
      }
    } catch (error) {
      console.error('[supabaseAuthStorage] setItem failed:', error);
    }
  },

  removeItem: (key) => {
    try {
      local.removeItem(key);
      session.removeItem(key);
    } catch (error) {
      console.error('[supabaseAuthStorage] removeItem failed:', error);
    }
  },
});

export { isAuthStorageKey };
